export default "__VITE_ASSET__Dj6W$hK0__"